import { render, staticRenderFns } from "./vBackOfPackageConfig.vue?vue&type=template&id=0a485126&scoped=true"
import script from "./vBackOfPackageConfig.vue?vue&type=script&lang=ts"
export * from "./vBackOfPackageConfig.vue?vue&type=script&lang=ts"
import style0 from "./vBackOfPackageConfig.vue?vue&type=style&index=0&id=0a485126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a485126",
  null
  
)

export default component.exports